// Mock data for the portfolio website - with actual blog content from iambivas.in

export const personalInfo = {
  name: "Bivas Mishra",
  title: "Content Creator & Senior Business Analyst",
  tagline: "Empowering Your Narrative: Where Every Story Finds Its Unique Voice and Flourishes",
  bio: "Results-driven Business Analyst at Quoreka, serving EMEA clients like Alvean Sugar. Founder & Host of \"Wickwise Pod\" (formerly The UnMic Show), inspiring change on Spotify. India Operations Executive for BRICS CCI Young Leaders, pioneering collaborations. Co-Founder of S.I.A.B., CEO of \"Spasmodic\" at Lovely Professional University, fostering student innovation. Integrated B. Com-MBA from Mittal School, specializing in Marketing and Finance. 55+ months of experience in event management, team coordination, and digital marketing.",
  profileImage: "https://customer-assets.emergentagent.com/job_glassy-portfolio-8/artifacts/no8gzp4b_1747029237795.jpg",
  social: {
    twitter: "https://x.com/mishra_bivas",
    linkedin: "https://www.linkedin.com/in/bivas-mishra/",
    instagram: "https://www.instagram.com/thebivasmishra/"
  }
};

// Brands migrated to MongoDB — see /api/brands. Seeded defaults in backend/server.py.

export const yourstoryInfo = {
  title: "Bivas Mishra is the Co-founder & CEO of Spasmodic Group. He previously worked as Digital Marketing Intern at Omnibulls. He completed his studies at Lovely Professional University.",
  link: "https://yourstory.com/companies/spasmodic-group",
  logo: "https://customer-assets.emergentagent.com/job_glassy-portfolio-8/artifacts/jikig7yb_Yourstory.jpg"
};
// testimonials moved to MongoDB — see /api/testimonials.
export const navItems = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Wickwise Pod", href: "/wickwise" },
  { label: "SubMerge", href: "/submerge" },
  { label: "Travel", href: "/travel" },
  { label: "Testimonials", href: "/testimonials" },
  { label: "Contact", href: "/contact" }
];
